<template>
  <div class="availability-bottom-button">
    <div
      v-if="ordered && cancelTo"
      class="cancel-to"
    >
      <template v-if="canCancel">
        {{ $t('shop.cancelTo') }}: {{ formatDate(cancelTo) }}
      </template>
      <template v-else>
        {{ $t('shop.cancellationExpired') }}
      </template>
    </div>
    <div
      v-if="!ordered && !canOrderFrom"
      class="order-disabled"
    >
      {{ $t('shop.orderAvailableFrom') }}: {{ formatDate(orderFrom) }}
    </div>
    <div
      v-if="!ordered && !canOrderTo"
      class="order-disabled"
    >
      {{ $t('shop.orderAvailableTo') }}: {{ formatDate(orderTo) }}
    </div>
    <div
      v-if="!ordered && countExceeded && status !== 'reserveQueue'"
      class="order-disabled"
    >
      {{ $t('shop.noSpotsAvailable') }}
    </div>
    <div class="button-wrapper">
      <button
        class="btn"
        :class="buttonClass"
        :disabled="isDisabled"
        @click="onToggle"
      >
        <i
          :class="buttonIcon"
          class="pr-2"
        />
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    status: {
      type: String,
      required: true,
    },
    availability: {
      type: Object,
      required: true,
    },
    cancelTo: {
      type: String,
      required: true,
    },
    orderFrom: {
      type: String,
      default: undefined,
    },
    orderTo: {
      type: String,
      default: undefined,
    },
    countExceeded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ordered() {
      return ['paid', 'unpaid', 'paidCancelled', 'unpaidCancelled'].includes(this.status);
    },
    canCancel() {
      return !this.cancelTo || moment(this.cancelTo).isAfter(moment());
    },
    canOrderFrom() {
      return !this.orderFrom || moment(this.orderFrom, 'YYYY-MM-DD HH:mm').isBefore(moment());
    },
    canOrderTo() {
      return !this.orderTo || moment(this.orderTo, 'YYYY-MM-DD HH:mm').isAfter(moment());
    },
    isDisabled() {
      if (this.ordered) {
        return !this.canCancel;
      }
      return !this.canOrderFrom || !this.canOrderTo;
    },
    buttonText() {
      if (this.status === 'reserveQueue') return 'Usuń z listy rezerwowej';
      if (this.status === 'available' && this.countExceeded) return this.$t('shop.addToBasketReserve');
      if (this.status === 'available') return this.$t('shop.addToBasket');
      if (this.status === 'inBasket') return this.$t('shop.removeFromBasket');
      if (this.status === 'paid' || this.status === 'unpaid') return this.$t('shop.cancel');
      if (this.status === 'unpaidCancelled' || this.status === 'paidCancelled') return this.$t('shop.undoCancellation');
      return '';
    },
    buttonIcon() {
      if (this.status === 'reserveQueue') return 'far fa-times';
      if (this.status === 'available' && this.countExceeded) return 'far fa-clock';
      if (this.status === 'available') return 'fas fa-plus';
      if (this.status === 'inBasket') return 'fas fa-rotate-left';
      if (this.status === 'paid' || this.status === 'unpaid') return 'fas fa-ban';
      if (this.status === 'unpaidCancelled' || this.status === 'paidCancelled') return 'fas fa-rotate-left';
      return '';
    },
    buttonClass() {
      if (this.status === 'reserveQueue') return 'btn-danger';
      if (this.status === 'available') return 'btn-primary';
      return 'btn-secondary';
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD MMM HH:mm');
    },
    onToggle() {
      this.$emit('toggle');
    },
  },
};
</script>

<style lang="scss" scoped>
.availability-bottom-button {
  background-color: #fff;
  padding: 10px 0;
}

.cancel-to {
  text-align: center;
  font-size: 12px;
  color: #666;
}

.order-disabled {
  color: #666;
  font-size: 12px;
  padding-left: 20px;
}

.button-wrapper {
  margin: 10px 20px;
}

.btn {
  height: 50px;
  border-radius: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
